import type { Middleware } from 'openapi-fetch';
import {
  captureCsrfToken,
  clearCsrfToken,
  CSRF_HEADER,
  CSRF_SAFE_METHODS,
  getCsrfToken,
} from './csrf';
import { triggerUnauthorized } from './unauthorized';

/**
 * Auth-flow endpoints carry their own 401 semantics: here a 401 is a credential or
 * not-yet-authenticated signal the calling page handles locally (LoginError on the login
 * form, ChangePasswordError on a wrong current password, UnauthenticatedError driving the
 * SPA's login UI) — not a dead session to bounce on. For every other endpoint a 401 means
 * the session died, so we raise the global unauthorized signal.
 */
const AUTH_FLOW_401_PATHS = new Set([
  '/api/v1/auth/login',
  '/api/v1/auth/me',
  '/api/v1/auth/me/password',
]);

export const csrfMiddleware: Middleware = {
  async onRequest({ request }) {
    if (!CSRF_SAFE_METHODS.has(request.method.toUpperCase())) {
      const token = getCsrfToken();
      if (token) request.headers.set(CSRF_HEADER, token);
    }
    return request;
  },
  async onResponse({ response, schemaPath }) {
    captureCsrfToken(response);
    if (response.status === 401 && !AUTH_FLOW_401_PATHS.has(schemaPath)) {
      clearCsrfToken();
      triggerUnauthorized();
    }
    return response;
  },
};
